import React from 'react';
import MainTemplate from 'pages/templates/MainTemplate';
import PriEprs from './PriEprs';

const adverPriEprs = () => {
  return (
    <MainTemplate>
      <PriEprs />
    </MainTemplate>
  );
};

export default adverPriEprs;
